<template>
  <v-container>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <div v-if="finished">
        <h2>Your request has been sent. We will be in touch shortly.</h2>
        <v-btn color="primary" @click.stop="onLogout" class="cursor">Log Out</v-btn>
      </div>

        <v-stepper v-if="!finished" v-model="step" vertical class="pfStepper">
          <h3 class="issueH">Issue: {{ $route.params.type }}</h3>
          <v-stepper-step step="1" :complete="step > 1">
           About the Issue
            <small>Please provide as much information as possible</small>
          </v-stepper-step>
          
          <v-stepper-content step="1">
            <v-form data-vv-scope="form-1" style="padding: 10px;">
             <v-layout row>
                  <v-flex lg12>
                    <v-switch label="Is your issue related to an appliance?" v-model="switchApp"></v-switch>
                  </v-flex>
                </v-layout>
                <transition name="component-fade" appear>
             <v-layout row v-if="switchApp">
                  <v-flex lg12>
                    <v-text-field 
                    box
                    v-model="applianceType" hint="eg TV, Boiler etc" label="Type of appliance" 
                    :error-messages="errors.collect('applianceType')" 
                    v-validate="'max:30'" 
                    data-vv-name="applianceType" required data-vv-scope="form-1">
                  </v-text-field>
                  </v-flex>
                </v-layout>
                </transition>
                <transition name="component-fade" appear>
             <v-layout row v-if="switchApp">
                  <v-flex lg12>
                    <v-text-field 
                    box
                    v-model="applianceMake" label="Appliance Make" 
                    :error-messages="errors.collect('applianceMake')" 
                    v-validate="'max:30'" 
                    data-vv-name="applianceMake" required data-vv-scope="form-1">
                  </v-text-field>
                  </v-flex>
                </v-layout>
                </transition>
              <transition name="component-fade" appear>
             <v-layout row v-if="switchApp">
                  <v-flex lg12>
                    <v-text-field 
                    box
                    v-model="applianceSerial" hint="If you can see a serial number, what is it?"  label="Appliance serial number" 
                    :error-messages="errors.collect('applianceSerial')" 
                    v-validate="'max:30'" 
                    data-vv-name="applianceSerial" required data-vv-scope="form-1">
                  </v-text-field>
                  </v-flex>
                </v-layout>
                </transition>
             <v-layout row>
                  <v-flex lg12>
                    <v-textarea
                    box
                    v-model="issueText" label="Description of repair / issue" hint="Please describe the issue in as much detail as possible" 
                    :error-messages="errors.collect('issueText')" 
                    auto-grow
                    v-validate="'required|max:3000'" 
                    data-vv-name="issueText" required data-vv-scope="form-1">
                  </v-textarea>
                  </v-flex>
                </v-layout>
                
            <v-btn color="primary" @click.native="submitForm('form-1')">Continue</v-btn>
          </v-form>
          </v-stepper-content>

          <v-stepper-step step="2" :complete="step > 2">Upload an photo</v-stepper-step>
          <v-stepper-content step="2">
 <v-layout row>
            <v-flex xs12>
              <transition name="component-fade" appear>
                <v-layout row v-if="imageUrl">
                  <v-flex lg12>
              <img :src="imageUrl" style="height: 150px;">
                </v-flex>
                </v-layout>
              </transition>
              <v-layout row>
              <v-flex lg12>
              <v-btn class="primary" raised @click="onPickFile">Upload Image</v-btn>
              </v-flex>
               </v-layout>
              </transition>
              <input 
              type="file" 
              ref="fileInput" 
              accept="image/*"
              @change="onFilePicked"
              style="display:none"
              >
              <v-progress-linear v-if="showProgress" v-model="progressUpload"></v-progress-linear>
            </v-flex>
            </v-layout>
            <v-btn color="primary" @click.native="step = 3">Continue</v-btn>
            <v-btn flat @click.native="goBack">Go Back</v-btn>
          </v-stepper-content>
          <v-stepper-step step="3" :complete="step > 3">Contact details and consent</v-stepper-step>
          <v-stepper-content step="3">
             <v-form data-vv-scope="form-3" style="padding: 10px;">
            <v-layout row>
              <v-flex lg12>
                <v-text-field 
                box
                v-model="contactName" label="Contact Name" 
                :error-messages="errors.collect('contactName')" 
                v-validate="'required|max:60'" 
                data-vv-name="applianceType" required data-vv-scope="form-3">
              </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex lg12>
                <v-text-field 
                box
                v-model="tel" hint="What is the best telephone number to contact you on?"  label="Telephone Number" 
                :error-messages="errors.collect('tel')" 
                v-validate="'required|max:30'" 
                data-vv-name="tel" required data-vv-scope="form-3">
              </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex lg12>
                <v-text-field 
                box
                v-model="tel2" hint="What is an alternative number to contact you on?"  label="Additional Number" 
                :error-messages="errors.collect('tel2')" 
                v-validate="'max:30'" 
                data-vv-name="tel2" required data-vv-scope="form-3">
              </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex lg12>
                <v-text-field 
                box
                v-model="dayTime" label="Access times available / arrangements" hint="Please give a good day and time for the repair work to be carried out" 
                :error-messages="errors.collect('dayTime')" 
                v-validate="'max:30'" 
                data-vv-name="dayTime" required data-vv-scope="form-3">
              </v-text-field>
              </v-flex>
            </v-layout>
           <v-layout row>
              <v-flex lg12>
                <v-checkbox
                label="I give permission for third party contrators to access the property using management keys. "
                v-model="permission"
                :error-messages="errors.collect('permission')"
                v-validate="'required'"
                data-vv-name="permission" required 
                data-vv-scope="form-3"
              ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex lg12>
                <v-checkbox
                label="I consent to my personal details being passed on to third party contrators to complete the repair work."
                v-model="consent"
                :error-messages="errors.collect('consent')"
                v-validate="'required'"
                data-vv-name="consent" required 
                data-vv-scope="form-3"
    ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-btn color="primary" @click.native="submitForm('form-3')" ripple :disabled="loading" v-if="!loading">Send Request</v-btn>
            <v-btn flat @click.native="goBack">Go Back</v-btn>
             </v-form>
          </v-stepper-content>
          <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        </v-stepper>
    </v-flex>
    </v-layout>
 </v-container>
</template>

<script>
//  import firebaseApp from '../modules/firebase/firebaseInit'
import shared from '../mixins/shared'
import axios from 'axios'

export default {
  mixin: [shared],
  $_veeValidate: {
    validator: 'new'
  },
  mounted () {
    this.$validator.localize('en', this.dictionary)
  },
  name: 'issuerequest',
  data () {
    return {
      finished: false,
      loading: false,
      step: 0,
      switchApp: false,
      applianceType: '',
      appliance: false,
      applianceSerial: '',
      applianceMake: '',
      issueText: '',
      contactName: this.currentUser().firstName + ' ' + this.currentUser().lastName,
      tel: this.currentUser().telephone,
      tel2: '',
      email: this.currentUser().email,
      address1: this.currentUser().address1,
      address2: this.currentUser().address2,
      town: this.currentUser().town,
      county: this.currentUser().county,
      postcode: this.currentUser().postcode,
      dayTime: '',
      imageUrl: '',
      consent: null,
      permission: null,
      image: null,
      uploadTask: '',
      progressUpload: 0,
      showProgress: false,
      downloadURL: ''
    }
  },
  methods: {
    submitForm (scope) {
      if (scope === 'form-3') {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.request()
          }
        })
      } else {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.step++
          }
        })
      }
    },
    toggleApp () {
      this.appliance = !this.appliance
    },
    goBack () {
      this.step--
    },
    onPickFile () {
      this.$refs.fileInput.click()
    },
    // onFilePicked (event) {
    //   this.showProgress = true
    //   const files = event.target.files
    //   let fileName = files[0].name
    //   if (fileName.lastIndexOf('.') <= 0) {
    //     return alert('valid file')
    //   }
    //   let fileReader = new FileReader()
    //   fileReader.addEventListener('load', () => {
    //     // this.imageUrl = fileReader.result
    //   })
    //   fileReader.readAsDataURL(files[0])
    //   const name = Math.random().toString(36).substr(2, 9)
    //   const ext = fileName.slice(fileName.lastIndexOf('.'))
    //   this.uploadTask = this.$fb.storage().ref('images/' + name + ext).put(files[0])
    //   this.uploadTask.then(snapshot => {
    //     this.imageUrl = this.uploadTask.snapshot.downloadURL
    //     // this.downloadURL = this.uploadTask.snapshot.downloadURL
    //     this.showProgress = false
    //   })
    //   .catch(e => {
    //     this.addNotification({text: 'An Error Occurred, try again later', color: 'error'})
    //     this.showProgress = false
    //   })
    // },
    onFilePicked (e) {
      this.showProgress = true
      const files = e.target.files
      let fileName = files[0].name
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      reader.onload = event => {
        const img = new Image()
        img.src = event.target.result
        img.onload = () => {
          const elem = document.createElement('canvas')
          const width = 1000
          const scaleFactor = width / img.width
          elem.width = width
          elem.height = img.height * scaleFactor
          const ctx = elem.getContext('2d')
          // img.width and img.height will give the original dimensions
          ctx.drawImage(img, 0, 0, width, img.height * scaleFactor)
          ctx.canvas.toBlob((blob) => {
            const file = new File([blob], fileName, {
              type: 'image/jpeg',
              lastModified: Date.now()
            })
            this.uploadTask = this.$fb.storage().ref('images/' + name + 'jpg').put(file)
            this.uploadTask.then(snapshot => {
              this.imageUrl = this.uploadTask.snapshot.downloadURL
              // this.downloadURL = this.uploadTask.snapshot.downloadURL
              this.showProgress = false
            })
            .catch(e => {
              this.addNotification({text: 'An Error Occurred, try again later', color: 'error'})
              this.showProgress = false
            })
          }, 'image/jpeg', 1)
        }
        reader.onerror = error => console.log(error)
      }
    },
    onLogout () {
      this.finished = false
      this.resetData()
      this.$fb.auth().signOut()
      this.$store.dispatch('logout')
      this.$router.push('/')
    },
    resetData () {
      this.step = 0
      this.switchApp = false
      this.applianceType = ''
      this.appliance = false
      this.applianceSerial = ''
      this.applianceMake = ''
      this.issueText = ''
      this.dayTime = ''
      this.imageUrl = ''
      this.consent = null
      this.image = null
    },
    request () {
      this.loading = true
      const body = {
        appCategory: this.$route.params.type,
        switchApp: this.switchApp,
        applianceType: this.applianceType,
        appliance: this.appliance,
        applianceSerial: this.applianceSerial,
        applianceMake: this.applianceMake,
        issueText: this.issueText,
        contactName: this.contactName,
        permission: this.permission,
        consent: this.consent,
        tel: this.tel,
        tel2: this.tel2,
        email: this.email,
        address1: this.address1,
        address2: this.address2,
        town: this.town,
        county: this.county,
        postcode: this.postcode,
        dayTime: this.dayTime,
        imageUrl: this.imageUrl
      }
      this.$fb.auth().currentUser.getIdToken().then((token) => {
        axios({
          method: 'post',
          data: body,
          url: 'https://us-central1-propertyfirst-ee59e.cloudfunctions.net/app/request',
          headers: { 'Authorization': 'Bearer ' + token }
        })
        .then(response => {
          // JSON responses are automatically parsed
          this.loading = false
          this.finished = true
          // this.addNotification({text: 'Your request has been sent. We will be in touch shortly.', color: 'success'})
          this.resetData()
        })
        .catch(e => {
          this.addNotification({text: 'An Error Occurred, try again later', color: 'error'})
          console.log(e)
          this.loading = false
        })
      })
    }
  },
  watch: {
    uploadTask () {
      this.uploadTask.on('state_changed', sp => {
        this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@media only screen and (max-width : 800px) {
  .pfStepper {
    background: transparent;
    box-shadow: none;
    padding:  0;
  }
  .theme--light .v-stepper {
    background: transparent;
  }
  .pfStepper.v-stepper--vertical .v-stepper__step {
      padding: 22px 14px 14px 14px;
  }
  .pfStepper.v-stepper--vertical .v-stepper__content {
      margin: -8px -36px -16px 26px;
      padding: 16px 60px 16px 23px;
      width: auto;
  }
}
.issueH {
  padding: 20px 20px 5px 25px;
}
  h1 {
    font-size: 30px;
    margin: 30px 0;
  }
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}

.component-fade-enter, .component-fade-leave-to {
  opacity: 0;
}
.type {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// IssueRequest.vue?f910b4c4